import { Warrior } from '~/../api/common.types';
import { getCurrentWarrior } from '~/utils/utils';

function ReviveWarrior({
  deadWarrior,
  reviveId,
  setReviveId,
  setDeadWarriorIds,
}: {
  deadWarrior: Warrior;
  reviveId: string | null;
  setReviveId: any;
  setDeadWarriorIds: any;
}) {
  const warriorData = getCurrentWarrior(deadWarrior);

  return (
    <button
      className={`grid__item ${
        reviveId && reviveId == deadWarrior.warrior_id.toString() ?
          'is-selected' :
          ''
      }`}
      onClick={() => {
        setDeadWarriorIds([]);
        setReviveId(deadWarrior.warrior_id.toString());
      }}
    >
      <img src={warriorData.images.dead} alt={warriorData.name} />
      <h4>{warriorData.name}</h4>
      <p>
        Level {warriorData.level}, HP {warriorData.hp}, Type {warriorData.type},
        Syndicate {warriorData.syndicate}
      </p>
    </button>
  );
}

function ReviveWarriors({
  deadWarriors,
  reviveId,
  setReviveId,
  setDeadWarriorIds,
}: {
  deadWarriors: Array<Warrior> | undefined;
  reviveId: string | null;
  setReviveId: any;
  setDeadWarriorIds: any;
}) {
  return (
    <div className="grid-revive-warriors">
      {deadWarriors?.map((warrior, i) => (
        <ReviveWarrior
          deadWarrior={warrior}
          key={i}
          reviveId={reviveId}
          setReviveId={setReviveId}
          setDeadWarriorIds={setDeadWarriorIds}
        />
      ))}
    </div>
  );
}

export default ReviveWarriors;
